import "./index.scss"
import Sloth from "../../components/Sloth";

@Sloth.component({
    defaultOptions : {}
})

export default class HeaderSearch {

    constructor() {
        this.open = false
    }

    get inputText() {
        return $("input", this.dom).val().trim() || ''
    }

    onInit() {
        $(this.dom).on("click", (e) => {
            if(this.open && !$(e.target).is("input") && this.inputText) return this.submit()

            this.open = true
            $("input", this.dom).focus()
            this.render()
        });

        $(document.body).on("click", (e) => {
            if($(e.target).is(".Header-search")) return;

            if($(e.target).parents(".Header-search").length === 0){
                this.open = false
                this.render()
            }
        })
    }

    submit() {
        $(this.dom).submit();
    }

    render() {
        if(this.open) $(this.dom).addClass("open")
        else $(this.dom).removeClass("open")
    }
}



/** WEBPACK FOOTER **
 ** ./src/Search/index.js
 **/